var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E91E63",
    d: "M5,10c0-2.209,1.791-4,4-4h28c2.209,0,4,1.791,4,4v28c0,2.209-1.791,4-4,4H9c-2.209,0-4-1.791-4-4V10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#16020B",
    d: "M26.283,22.553c-0.508,0-0.879,0.205-1.113,0.615s-0.352,1.14-0.352,2.188v0.732c0,1.042,0.111,1.77,0.332,2.183c0.221,0.413,0.596,0.62,1.123,0.62c0.547,0,0.961-0.244,1.24-0.732v-4.824C27.24,22.813,26.83,22.553,26.283,22.553z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#16020B",
    d: "M8,9v30h30V9H8z M20.141,31H17.27V16.781h2.871V31z M30.297,31h-2.51l-0.127-1.074c-0.566,0.847-1.295,1.27-2.188,1.27c-1.107,0-1.952-0.423-2.534-1.27s-0.88-2.09-0.894-3.73v-0.801c0-1.731,0.293-3.024,0.879-3.877s1.439-1.279,2.559-1.279c0.814,0,1.49,0.352,2.031,1.055V16h2.783V31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndesign);
export default __webpack_public_path__ + "static/media/indesign.7c9c8ae98c15ea6b75e8aaa8cbcd868f.svg";
export { ForwardRef as ReactComponent };